module.exports = __webpack_public_path__ + "img/35_22.87f88c1e.png";